module.exports = __webpack_public_path__ + "static/img/pay-zfb.fb72639e.png";